function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcon = function SvgIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 128 128"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "m54.215 16.409-2.685 2.684L6.622 64.001l47.593 47.59 5.369-5.369-8.922-8.92.002-.001L17.363 64 52.84 28.523l1.374-1.374 5.369-5.37Zm19.572.002-2.684 2.684-44.906 44.906 47.59 47.59 47.59-47.59zm0 10.738 36.852 36.852-36.852 36.852L36.935 64Z",
    style: {
      fill: "#7a00d9"
    }
  }));
};
export default SvgIcon;